import { HTMLAttributes } from "react";
import { cn } from "../../utils/classes";
import styles from "./pill.module.css";

export const Pill = ({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn(styles.pill, className)} {...props}>
    {children}
  </div>
);

Pill.Error = ({
  children = <>Error</>,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <Pill className={cn(styles.error, className)}>{children}</Pill>
);
